import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import api_data from '../../../../data/TableData'
import './FilterTable.css'

const products = api_data['ExpiratedLicense']

export default function SecondaryButtonFilterCompany() {
    const [company, setCompany] = useState('');

    const handleChange = (event) => {
        setCompany(event.target.value);
    };

    return (
        <div className='SeconFilterTableContainer'>
            <FormControl variant="standard" sx={{ m: 2, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-standard-label">Empresa</InputLabel>
                <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={company}
                    onChange={handleChange}
                    label="Name"
                >
                    <MenuItem value="">
                        <em>Todas</em>
                    </MenuItem>
                    {products.map((row, i) => <MenuItem value={i}>{row.name}</MenuItem>)}
                </Select>
            </FormControl>
        </div>
    )
}



